// share() helper (§7). Uses the Web Share API when available (mobile / Capacitor
// native sheet), otherwise falls back to copying to the clipboard. Returns a
// short status so callers can toast "Shared!" / "Copied!".
export type ShareResult = "shared" | "copied" | "failed";

const SITE = "https://www.mysticrafter.com";

export async function share(text: string, url: string = SITE): Promise<ShareResult> {
  const payload = { title: "MystiCrafter", text, url };
  try {
    if (typeof navigator !== "undefined" && (navigator as any).share) {
      await (navigator as any).share(payload);
      return "shared";
    }
  } catch (err: any) {
    // User cancelled the native sheet — not an error worth surfacing.
    if (err && err.name === "AbortError") return "failed";
  }
  try {
    if (typeof navigator !== "undefined" && navigator.clipboard) {
      await navigator.clipboard.writeText(`${text} ${url}`);
      return "copied";
    }
  } catch {
    /* fall through */
  }
  return "failed";
}
